import React, {Component} from 'react';
import {Card, Divider, message, Modal, Tag} from 'antd';
import {Link} from 'react-router';

import moment from 'moment';
import {getMonthNums} from '@util/formatDate';
import {queryRelateStation} from '@api/incubator/settled';

import DescriptionList from '@comm/DescriptionList';
import TableFile from '../../comm/TableFile';
import TipsOverdue from '../../comm/TipsOverdue';
import ComSeatTable from '../../seat/ComSeatTable';

const { Description } = DescriptionList;

export default class Base extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seatVisible: false,
      originalPrice: '',
      discount: 0,
    };
  }

  componentDidMount() {
    const { dataInfo } = this.props;
    if (dataInfo && dataInfo.stations && dataInfo.stations.length > 0) {
      const diffMonth = getMonthNums(
        moment(dataInfo.beginDate).format('YYYY-MM-DD'),
        moment(dataInfo.endDate).format('YYYY-MM-DD'),
      );
      const stationsPrice = dataInfo.stations.reduce((prev, curr) => prev + curr.unit, 0);
      const originalPrice = diffMonth * stationsPrice;
      const discount = ((dataInfo.price / originalPrice) * 100).toFixed(2);
      this.setState({ originalPrice, discount });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { dataInfo } = nextProps;
    if (
      dataInfo.uuid !== this.props.dataInfo.uuid &&
      dataInfo &&
      dataInfo.stations &&
      dataInfo.stations.length > 0
    ) {
      const diffMonth = getMonthNums(
        moment(dataInfo.beginDate).format('YYYY-MM-DD'),
        moment(dataInfo.endDate).format('YYYY-MM-DD'),
      );
      const stationsPrice = dataInfo.stations.reduce((prev, curr) => prev + curr.unit, 0);
      const originalPrice = diffMonth * stationsPrice;
      const discount = ((dataInfo.price / originalPrice) * 100).toFixed(2);
      this.setState({ originalPrice, discount });
    }
  }

  handleSeatVisible = flag => {
    this.setState({
      seatVisible: !!flag,
    });
  };

  handleChange = (uuids, price, disableLen) => {
    this.uuids = uuids;
  };

  handleSetStation = () => {
    const { dataInfo } = this.props;
    queryRelateStation({
      uuid: dataInfo.uuid,
      stationUuids: this.uuids,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.loadDetail();
        this.handleSeatVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo, type } = this.props;
    const { seatVisible, originalPrice, discount } = this.state;
    const typeFont = ['工位收入', '地址收入'];
    const businessType = ['在签', '待归档', '已归档'];
    const businessStatus = dataInfo.businessStatus || {};
    const termination = dataInfo.termination || {};
    const title = <TipsOverdue interval={businessStatus.interval} />;
    const extra = <Tag color="#108ee9">{businessType[businessStatus.status]}</Tag>;
    const customLink = (
      <Link to={`/incubator/${dataInfo.incubatorUuid}/custom/detail/${dataInfo.customUuid}`}>
        {dataInfo.custom}
      </Link>
    );
    const businessEndDateElement = dataInfo.endDate
      ? moment.unix(dataInfo.endDate / 1000).format('YYYY-MM-DD')
      : '';
    return (
      <Card title={title} className="mb16" extra={extra}>
        <DescriptionList size="large" col={3}>
          <Description term="公司名称">{customLink}</Description>
          <Description term="项目名称">{dataInfo.projectName}</Description>
          <Description term="孵化器">
            <Link to={`/incubator/one/${dataInfo.incubatorUuid}/detail/bill`}>
              {dataInfo.incubator}
            </Link>
          </Description>
          <Description term="收入类型">{typeFont[dataInfo.type]}</Description>
          <Description term="使用工位">
            {type === 'termition' ? (
              <span>{dataInfo.stationNum}</span>
            ) : (
              <a onClick={() => this.handleSeatVisible(true)}>
                {dataInfo.stationNum || '关联工位'}
              </a>
            )}
          </Description>
          <Description term="记租时间">
            {dataInfo.beginDate ? moment.unix(dataInfo.beginDate / 1000).format('YYYY-MM-DD') : ''}
          </Description>
          <Description term="到期时间">
            {termination.status === 1 && termination.endDate ? (
              <span>{`${moment
                .unix(termination.beginDate / 1000)
                .format('YYYY-MM-DD')}(原${moment
                .unix(dataInfo.endDate / 1000)
                .format('YYYY-MM-DD')})`}</span>
            ) : (
              businessEndDateElement
            )}
          </Description>
          <Description term="合同金额">
            {dataInfo.price}
            {+discount > 0 && +discount < 100 ? (
              <span style={{ color: 'red', paddingLeft: '10px' }}>
                (原价{originalPrice}元，折扣{discount}%)
              </span>
            ) : (
              ''
            )}
          </Description>
          <Description term="押金">{dataInfo.indeposit}</Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="附件">
            <TableFile dataSource={dataInfo.files || []} disabled />
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="备注">{dataInfo.reason}</Description>
        </DescriptionList>

        {seatVisible ? (
          <Modal
            visible={seatVisible}
            width={900}
            title="选择工位"
            onOk={this.handleSetStation}
            onCancel={() => this.handleSeatVisible(false)}
          >
            <ComSeatTable
              {...this.props}
              incubatorUuid={dataInfo.incubatorUuid}
              stations={dataInfo ? dataInfo.stations : []}
              ref={node => {
                this.seatTable = node;
              }}
              handleChange={this.handleChange}
            />
          </Modal>
        ) : null}
        {termination.status === 1 && termination.endDate ? (
          <div>
            <Divider />
            <DescriptionList size="large" col={1}>
              <Description term="合同终止时间">
                {moment.unix(termination.beginDate / 1000).format('YYYY-MM-DD')}
              </Description>
            </DescriptionList>
            <DescriptionList size="large" col={1}>
              <Description term="附件">
                <TableFile dataSource={termination.files || []} disabled />
              </Description>
            </DescriptionList>
            <DescriptionList size="large" col={1}>
              <Description term="备注">{termination.reason}</Description>
            </DescriptionList>
          </div>
        ) : null}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/StationBase.js